import api from "../../../../Seating/Security/api";
import DialogUpdateServiceQuotePart from "../../../Dialog/DialogUpdateServiceQuotePart";
import CardQueueDataGrid from "../CardQueueDataGrid";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";

export default class CardQueueDataGridServiceQuotePart extends CardQueueDataGrid {
  columns = {
    "service_quote_part.id": {
      type: "number",
      name: "Part #",
      width: 130,
    },
    "service_quote_part.location_id": {
      type: "location",
      name: "Location",
      width: 140,
    },
    "service_quote_part.order_activity_id": {
      type: "number",
      name: "Order #",
      width: 120,
    },
    "service_quote_part.quantity": {
      type: "number",
      name: "Qty",
      width: 80,
    },
    "service_quote_part.received_at": {
      type: "date",
      name: "Received At",
      width: 180,
    },
    "service_quote_part.received_by_userprofile_id": {
      type: "user",
      name: "Received By User",
      width: 180,
    },
    "service_quote_part.service_part_catalog_id": {
      // Not used, but has to be here to avoid the error.
      type: "servicePartCatalog",
      name: "Part Name",
      width: 240,
    },
    "service_quote_part.product.product_sub_type_id": {
      // Not used, but has to be here to avoid the error.
      type: "string",
      name: "Part Name",
      width: 240,
    },
    "service_quote_part._part_name": {
      type: "serviceQuotePart.partName",
      name: "Part Name",
      width: 240,
    },
    "service_quote_part.warranty": {
      type: "boolean",
      name: "Warranty",
      width: 100,
    },
    "service_quote_part.order_activity.technician_id": {
      type: "user",
      name: "Technician",
      width: 120,
    },
    "service_quote_part.order_activity.setup_date": {
      type: "date",
      name: "Setup Date",
      width: 180,
    },
    "service_quote_part.order_activity.order_type": {
      type: "orderType",
      name: "Order Type",
      width: 180,
    },
    out_of_bounds: {
      type: "boolean",
      name: "OOB",
      width: 80,
    },
    "order_activity.id": {
      type: "Number",
      name: "Order ID",
      width: 150,
    },
    "service_quote_part.location.region_id": {
      type: "region",
      name: "Region",
      width: 90,
    },
    "service_quote_part.location.field_operations_region_id": {
      type: "region",
      name: "Region",
      width: 90,
    },
    "service_quote_part.service_quote_part_status_term_id": {
      type: "term",
      name: "Status",
      width: 180,
    },
    "service_quote_part.service_quote_part_source_term_id": {
      type: "term",
      name: "Source",
      width: 120,
    },
    "service_quote_part._queue_age": {
      type: "ageDays",
      name: "Age",
      width: 70,
    },
    "service_quote_part._queue_age_business": {
      type: "ageBusinessDays",
      name: "Age",
      width: 70,
    },
    "service_quote_part.service_quote_part_reason_term_id": {
      type: "term",
      name: "Reason",
      width: 180,
    },
    "service_quote_part._service_part_catalog_or_product_sub_type.vendor_id": {
      type: "vendor",
      name: "Vendor",
      width: 180,
    },
    "service_quote_part.credit_memo_number": {
      type: "string",
      name: "Credit Memo #",
      width: 150,
    },
    "service_quote_part.order_activity.service_location_id": {
      type: "location",
      name: "Service Location",
      width: 150,
    },
    "service_quote_part.order_activity.sales_location_id": {
      type: "location",
      name: "Sales Location",
      width: 150,
    },
    "service_quote_part.tracking_number": {
      type: "string",
      name: "Tracking #",
      width: 150,
    },
    "service_quote_part.rma_number": {
      type: "string",
      name: "RMA #",
      width: 150,
    },
    "service_quote_part.followup_date": {
      type: "date",
      name: "Followup Date",
      width: 150,
    },
    "service_quote_part._queue_entered_date": {
      type: "date",
      name: "",
      width: 110,
    },
  };

  constructor(props) {
    super(props);

    this.state.serviceQuoteParts = [];
    this.state.dialogUpdateServiceQuotePartOpen = false;
    this.state.isUpdating = false;
  }

  /**
   * Handles the saving of updated invoice changes.
   */
  handleOnSaveServiceQuotePartChanges(serviceQuoteParts) {
    this.setState({
      isUpdating: true,
    });

    const promises = [];

    serviceQuoteParts.forEach((serviceQuotePart) => {
      promises.push(api.send("PUT", "/serviceQuotePart", serviceQuotePart));
    });

    Promise.all(promises)
      .then(() => {
        NotistackEnqueueSnackbar("Part Return updated successfully!", {
          variant: "success",
        });
        this.setState({
          isUpdating: false,
          dialogUpdateServiceQuotePartOpen: false,
          serviceQuoteParts: [],
          serviceQuotePartsOriginal: [],
        });
        this.props.onReload();
      })
      .catch((err) => {
        NotistackEnqueueSnackbar("Error updating Part Return", {
          variant: "error",
        });
        this.setState({
          isUpdating: false,
        });
      });
  }

  /**
   * Render the Update Service Quote Part Dialog
   */
  renderInternal() {
    return (
      <DialogUpdateServiceQuotePart
        open={this.state.dialogUpdateServiceQuotePartOpen}
        onClose={() => {
          this.setState({
            dialogUpdateServiceQuotePartOpen: false,
            serviceQuoteParts: [],
          });
        }}
        onConfirm={(serviceQuoteParts) =>
          this.handleOnSaveServiceQuotePartChanges(serviceQuoteParts)
        }
        serviceQuoteParts={this.state.serviceQuoteParts}
        loading={this.state.isUpdating}
        queue={this.props.queue}
      />
    );
  }

  /**
   * Handle clicking on a grid row:
   * - Filters rows by the clicked order activity ID.
   * - Fetches all service quote parts associated with that order activity.
   * - For each part:
   *     - If it has a productId, fetch the product details and assign the product name.
   *     - If it has a servicePartCatalogId, lookup and assign the service part description.
   *     - Otherwise, set partName to an empty string.
   */
  async handleClickRow(clickedRow) {
    const allServiceQuotePartsPerOrder = this.props.rows.filter((row) => {
      return (
        row["service_quote_part.order_activity_id"] ===
        clickedRow["service_quote_part.order_activity_id"]
      );
    });

    try {
      const serviceQuoteParts = await api.send(
        "POST",
        `/serviceQuotePart/getByOrderActivityId/`,
        {
          orderActivityId: clickedRow["service_quote_part.order_activity_id"],
        },
      );

      const updatedParts = await Promise.all(
        serviceQuoteParts.map(async (serviceQuotePart) => {
          if (serviceQuotePart.productId) {
            const prod = await api.send(
              "GET",
              `/products/${serviceQuotePart.productId}`,
            );
            const product =
              this.context.productSubTypesIndexed[prod.productSubTypeId];
            serviceQuotePart.partName = product.name;
          } else if (serviceQuotePart.servicePartCatalogId) {
            const servicePart = Object.values(
              this.context.servicePartCatalogsIndexed,
            ).find(
              (servicePart) =>
                servicePart.id === serviceQuotePart.servicePartCatalogId,
            );
            serviceQuotePart.partName = servicePart?.description || "";
          } else {
            serviceQuotePart.partName = "";
          }

          return serviceQuotePart;
        }),
      );

      this.setState({
        serviceQuoteParts: updatedParts,
        dialogUpdateServiceQuotePartOpen: true,
        serviceQuotePartsOriginal: allServiceQuotePartsPerOrder,
      });
    } catch (err) {
      console.error("Error fetching service quote parts or product data:", err);
    }
  }
}
